module.exports = __webpack_public_path__ + "assets/img/8_1726.2980bea9.jpg";